import { a as _slicedToArray } from './_rollupPluginBabelHelpers-e71b1aad.js';
import React__default, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { n as nodeOrStringProp } from './PropTypes-e1e509ba.js';
import 'moment';

function Description(props) {
  var children = props.children,
    content = props.content,
    className = props.className,
    dontCrop = props.dontCrop,
    dontExpand = props.dontExpand,
    linesToShow = props.linesToShow;
  var descriptionCroppedHeight = linesToShow * 20; // 20 for line-height

  var descriptionContentRef = useRef();
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    descriptionContentHeight = _useState2[0],
    setDescriptionContentHeight = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    descriptionOpen = _useState4[0],
    setDescriptionOpen = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    descriptionLongerThanLimit = _useState6[0],
    setDescriptionLongerThanLimit = _useState6[1];

  // eslint-disable-next-line
  useEffect(function () {
    // Its called at the first render and after each component update.
    if (descriptionContentRef.current) {
      var currentDescriptionContentHeight = descriptionContentRef.current.clientHeight;
      setDescriptionContentHeight(currentDescriptionContentHeight);
    }
  });
  useEffect(function () {
    setDescriptionLongerThanLimit(descriptionContentHeight > descriptionCroppedHeight);
  }, [descriptionContentHeight, descriptionCroppedHeight]);
  var descriptionCroppedStyles = {
    maxHeight: "".concat(descriptionCroppedHeight, "px")
  };
  var descriptionNotCroppedStyles = {
    maxHeight: '1000rem'
  };
  var showExpandLink = !dontCrop && descriptionLongerThanLimit && !dontExpand;
  var cropDescription = !dontCrop && descriptionLongerThanLimit && !descriptionOpen || dontExpand;
  var croppedCls = descriptionLongerThanLimit && !descriptionOpen || dontExpand ? 'bf-description-cropped' : '';
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bf-description ".concat(className)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-description-visible-area ".concat(croppedCls),
    style: cropDescription ? descriptionCroppedStyles : descriptionNotCroppedStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-description-content",
    ref: descriptionContentRef
  }, children || content)), showExpandLink ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !descriptionOpen && /*#__PURE__*/React__default.createElement("div", {
    className: "bf-description-shadow"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "bf-description-trigger-wrapper"
  }, /*#__PURE__*/React__default.createElement("small", {
    className: "bf-description-trigger bf-text-link",
    onClick: function onClick() {
      return setDescriptionOpen(!descriptionOpen);
    }
  }, descriptionOpen ? 'Show less' : 'Show more'))) : null);
}
Description.defaultProps = {
  children: '',
  content: '',
  className: '',
  dontCrop: false,
  dontExpand: false,
  linesToShow: 4
};
Description.propTypes = {
  /**
  Description content
   */
  children: nodeOrStringProp,
  /**
  Description content
   */
  content: nodeOrStringProp,
  /**
  Custom className
   */
  className: PropTypes.string,
  /**
  Show full Description content withput being cropped
   */
  dontCrop: PropTypes.bool,
  /**
  Hide show more link
   */
  dontExpand: PropTypes.bool,
  /**
  Amount of lines to be shown when Description is cropped
   */
  linesToShow: PropTypes.number
};

export default Description;
//# sourceMappingURL=Description.js.map
